/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./palantir-content.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./palantir-content.component";
var styles_PalantirContentComponent = [i0.styles];
var RenderType_PalantirContentComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PalantirContentComponent, data: {} });
export { RenderType_PalantirContentComponent as RenderType_PalantirContentComponent };
export function View_PalantirContentComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_PalantirContentComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "palantir-content", [], null, null, null, View_PalantirContentComponent_0, RenderType_PalantirContentComponent)), i1.ɵdid(1, 49152, null, 0, i2.PalantirContentComponent, [], null, null)], null, null); }
var PalantirContentComponentNgFactory = i1.ɵccf("palantir-content", i2.PalantirContentComponent, View_PalantirContentComponent_Host_0, {}, {}, ["*"]);
export { PalantirContentComponentNgFactory as PalantirContentComponentNgFactory };
